import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { toggleMenu } from '../features/navigation/navigationSlice';

const navigationItems = [
  { id: 'home', path: '/', title: 'Home', icon: '🏠' },
  { id: 'blog', path: '/blog', title: 'Blog', icon: '📝' },
  { id: 'work', path: '/work', title: 'Work', icon: '💼' },
  { id: 'life', path: '/life', title: 'Life', icon: '🌟' },
  { id: 'contact', path: '/contact', title: 'Contact', icon: '📬' },
];

const MobileNavigation = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const { isMenuOpen } = useSelector((state) => state.navigation);

  const handleNavigation = (path) => {
    navigate(path);
    dispatch(toggleMenu());
  };

  return (
    <>
      {/* Menu Button */}
      <button
        className={`
          fixed left-4 top-4 z-50 p-2 rounded-lg
          bg-black/30 backdrop-blur-sm border border-gray-800
          text-white opacity-60 hover:opacity-100 transition-all
          ${isMenuOpen ? 'hidden' : 'block'}
        `}
        onClick={() => dispatch(toggleMenu())}
      >
        <svg 
          xmlns="http://www.w3.org/2000/svg" 
          className="h-6 w-6" 
          fill="none" 
          viewBox="0 0 24 24" 
          stroke="currentColor"
        >
          <path 
            strokeLinecap="round" 
            strokeLinejoin="round" 
            strokeWidth={2} 
            d="M4 6h16M4 12h16M4 18h16" 
          />
        </svg>
      </button>

      {/* Backdrop */}
      {isMenuOpen && (
        <div 
          className="fixed inset-0 z-40 bg-black/50 backdrop-blur-sm"
          onClick={() => dispatch(toggleMenu())}
        />
      )}

      {/* Navigation Menu */}
      <nav 
        className={`
          fixed left-0 top-0 h-screen w-64 z-50
          bg-black/30 backdrop-blur-sm border-r border-gray-800
          transform transition-transform duration-300 ease-in-out
          ${isMenuOpen ? 'translate-x-0' : '-translate-x-full'}
        `}
      >
        <div className="p-6">
          <div className="flex items-center justify-between mb-8">
            <h1 className="text-2xl font-bold text-white">Cody Cox</h1>
            <button
              className="p-2 rounded-lg text-white opacity-60 hover:opacity-100 transition-opacity"
              onClick={() => dispatch(toggleMenu())}
            >
              <svg 
                xmlns="http://www.w3.org/2000/svg" 
                className="h-6 w-6" 
                fill="none" 
                viewBox="0 0 24 24" 
                stroke="currentColor"
              >
                <path 
                  strokeLinecap="round" 
                  strokeLinejoin="round" 
                  strokeWidth={2} 
                  d="M6 18L18 6M6 6l12 12" 
                />
              </svg>
            </button>
          </div>

          <ul className="space-y-2">
            {navigationItems.map((item) => {
              const isActive = location.pathname === item.path;
              return (
                <li key={item.id}>
                  <button
                    onClick={() => handleNavigation(item.path)}
                    className={`
                      w-full text-left p-3 rounded-lg transition-all duration-200
                      ${isActive 
                        ? 'bg-blue-500/20 text-white' 
                        : 'text-gray-300 hover:bg-white/5 hover:text-white'
                      }
                    `}
                  >
                    <div className="flex items-center gap-3">
                      <span className="text-xl">{item.icon}</span>
                      <span className="font-medium">{item.title}</span>
                    </div>
                  </button>
                </li>
              );
            })}
          </ul>
        </div>
      </nav>
    </>
  );
};

export default MobileNavigation; 